/* 🤖 this file was generated by svg-to-ts */
export const siriusArrowDownRight: {
  name: 'arrow_down_right';
  data: string;
} = {
  name: 'arrow_down_right',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="display: block;"><path d="M6.53 5.47a.75.75 0 0 0-1.06 1.06l10.72 10.72H8.25a.75.75 0 0 0 0 1.5H18a.747.747 0 0 0 .75-.75V8.25a.75.75 0 0 0-1.5 0v7.94L6.53 5.47Z" fill="currentColor"/></svg>`
};
